import React from 'react';

// MUI
import { styled } from '@mui/system';
import { Button, Grid } from '@mui/material';
import {
  MoreHoriz,
  Link,
  Preview,
  TableRows,
  Code,
  FormatPaint,
  Settings,
} from '@mui/icons-material';

const TextButton = styled(Button)(({ theme }) => ({
  textTransform: 'unset !important',
  color: `${theme.palette.text.primary} !important`,
}));

function FormAdditionalButtons(props) {
  const { templateLoading } = props;
  return (
    <>
      <Grid item>
        <TextButton
          size={'small'}
          startIcon={<MoreHoriz />}
          onClick={props.handleSettings}
          disabled={templateLoading}
        >
          Form settings
        </TextButton>
      </Grid>
      <Grid item>
        <TextButton
          size={'small'}
          startIcon={<Preview />}
          onClick={props.handlePreview}
          disabled={templateLoading}
        >
          Preview
        </TextButton>
      </Grid>
      {props.isForm && (
        <Grid item>
          <TextButton
            size={'small'}
            startIcon={<Link />}
            onClick={props.handleLink}
            disabled={templateLoading}
          >
            Link
          </TextButton>
        </Grid>
      )}
      <Grid item>
        <TextButton
          size={'small'}
          startIcon={<TableRows />}
          onClick={props.handleData}
          disabled={templateLoading}
        >
          Submission data
        </TextButton>
      </Grid>
      {props.isForm && (
        <Grid item>
          <TextButton
            size={'small'}
            startIcon={<Code />}
            onClick={props.handleEmbed}
            disabled={templateLoading}
          >
            Embed
          </TextButton>
        </Grid>
      )}
      <Grid item>
        <TextButton
          size={'small'}
          startIcon={<Settings />}
          onClick={props.handleFormSettings}
          disabled={templateLoading}
        >
          Settings
        </TextButton>
      </Grid>
      <Grid item>
        <TextButton
          size={'small'}
          startIcon={<FormatPaint />}
          onClick={props.handleStyling}
          disabled={templateLoading}
        >
          Styling
        </TextButton>
      </Grid>
    </>
  );
}

export default FormAdditionalButtons;
